import { useEffect, useState } from 'react';
import { useErrorStore } from '../../store/models';

const OTP_RELATED_ACTIONS = new Set([
  'confirmSignIn',
  'confirmPhoneNumberVerification',
  'resendForOTP',
  'sendPhoneNumberVerificationCode',
  'updatePhoneNumber',
]);

function useOTPError () {
  const errStore = useErrorStore();

  const [error, setError] = useState(null);
  const [isLimitExceeded, setIsLimitExceeded] = useState(false);

  function checkLimitExceeded (errorObj) {
    if (!errorObj) return false;
    const message = errorObj.message || errorObj.code || '';
    return message.toLowerCase().includes('attempt limit exceeded') || message.toLowerCase().includes('user temporarily locked');
  }

  useEffect(() => {
    const authError = errStore?.authError;
    const action = authError && Object.keys(authError).find(k => OTP_RELATED_ACTIONS.has(k));
    const errorData = action ? authError[action] : null;

    setError(errorData ? { ...errorData } : null);
    setIsLimitExceeded(errorData ? checkLimitExceeded(errorData) : false);
  }, [errStore?.authError]);

  function clearError () {
    setError(null);
    setIsLimitExceeded(false);
  }

  return {
    error,
    clearError,
    isLimitExceeded,
  };
}

export default useOTPError;
